class DataLogger {
  static experience = import.meta.env.VITE_DATA_LOGGER_EXPERIENCE
  static authToken = import.meta.env.VITE_DATA_LOGGER_TOKEN

  constructor(sessionId) {
    this.sessionId = sessionId
    this.attemptId = 0

    this.initAttemptVariables()
  }

  initAttemptVariables() {
    this.timeResponseReceived = null
    this.timeAuthCandidate = null
    this.timeOpenCamera = null
    this.authTimeStamp = null
  }

  getDataLoggerExperience() {
    return DataLogger.experience
  }

  getAuthToken() {
    return DataLogger.authToken
  }

  getSessionId() {
    return this.sessionId
  }

  renewAttempt() {
    this.initAttemptVariables()
  }

  getAttemptId() {
    return this.attemptId
  }

  incrementAttemptId() {
    this.attemptId += 1
    this.renewAttempt()
  }

  getTimeAuthCandidateToResponseReceived() {
    return this.timeResponseReceived - this.timeAuthCandidate
  }

  getTimeOpenCameraToAuthCandidate() {
    return this.timeAuthCandidate - this.timeOpenCamera
  }

  recordTimeFor(key, renew = false) {
    if (renew || !this[key]) {
      this[key] = performance.now()
    }
  }

  recordTimeAuthCandidate(renew = false) {
    this.recordTimeFor('timeAuthCandidate', renew)
  }

  recordTimeResponseReceived(renew = false) {
    this.recordTimeFor('timeResponseReceived', renew)
  }

  recordTimeOpenCamera(renew = false) {
    this.recordTimeFor('timeOpenCamera', renew)
  }

  getTimeLoadPage() {
    let timeLoadPage = null

    /* Modern API
      https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
     */
    if (performance.getEntriesByType) {
      const navigationEntry = performance.getEntriesByType('navigation')[0]
      if (navigationEntry) {
        timeLoadPage = navigationEntry.loadEventEnd - navigationEntry.startTime
      }
    }

    /* Fallback to legacy API -- Deprecated.
      Supports in the old browsers
      https://developer.mozilla.org/en-US/docs/Web/API/PerformanceTiming
     */
    if (timeLoadPage === null && performance.timing) {
      const { navigationStart, loadEventEnd } = performance.timing
      timeLoadPage = loadEventEnd - navigationStart
    }

    return timeLoadPage
  }

  logScanData(
    uuid,
    deviceModel,
    browser,
    browserVersion,
    browserEngine,
    scanningURL,
    appVersion,
    authResult,
    authFailureMode,
    authStatus
  ) {
    const experience = this.getDataLoggerExperience()
    const token = this.getAuthToken()

    const data = {
      experience,
      key: {
        uuid,
        deviceModel,
        appVersion,
        browser,
        sessionId: this.getSessionId()
      },
      data: {
        deviceModel,
        browser,
        browserVersion,
        browserEngine,
        scanningURL,
        timeLoadPage: this.getTimeLoadPage(),
        timeOpenCameraToAuthCandidate: this.getTimeOpenCameraToAuthCandidate(),
        timeAuthCandidateToResponseReceived:
          this.getTimeAuthCandidateToResponseReceived(),
        authTimeStamp: this.authTimeStamp,
        authStatus,
        authResult,
        authFailureMode,
        attemptId: this.getAttemptId()
      }
    }
    console.log('dataLogger: ', data)
    const host = 'rnd.scantrust.io'

    fetch(`https://${host}/api/data-logger/log/`, {
      method: 'POST',
      credentials: 'same-origin',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${token}`
      },
      body: JSON.stringify(data)
    })
      .then((res) => {
        if (!res.ok) {
          console.error('Status: ' + res.status)
          return Promise.reject('server')
        } else {
          res.json()
        }
      })
      .then((data) => console.log('Logged successfully'))
      .catch((err) => {
        if (err !== 'server') console.log(err)
      })
  }
}

export default DataLogger
